module.exports = __webpack_public_path__ + "execute-worker-roles.9ea296e63b07a9538130fe6f06ffe364.hashedasset.svg";